import type { HomePageV2Supporter } from "../contentTypes";
import cnpq from "../../../assets/png/logo/cnpq.png";
import embrapii from "../../../assets/png/logo/embrapii.png";
import igGoiano from "../../../assets/png/logo/if-goiano.png";

export const apoiadoresContent: {
  headingLines: string[];
  body: string;
  supporters: HomePageV2Supporter[];
} = {
  headingLines: ["APOIO:", "APOIO:", "APOIO:"],
  body:
    "As empresas apoiadoras do Pastejo são marcas que entenderam que a tecnologia é uma aliada essencial para a evolução da pecuária de corte. Ao apoiar o aplicativo, fortalecem um movimento que leva mais controle, eficiência e inteligência para dentro da porteira.",
  supporters: [
    {
      name: "CNPq",
      image: cnpq
    },
    { 
      name: "EMBRAPII", 
      image: embrapii
    },
    { 
      name: "Instituto Federal Goiano", 
      image: igGoiano
    },
  ],
};
